import React, { useEffect, useState } from 'react';

/**
 * UnderArmour2027: Under Armour Türkiye 2027 ciro, kaynak ve medya bütçesi planı.
 * Route: /r/under-armour-2027 (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 14 slayt, 16:9, apple.com tasarım dili. Rakamlar model.py ile
 * ham dosyalardan üretilir, sonra:
 *   node src/pages/under-armour-2027/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 *
 * HTML modülü ~84KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function UnderArmour2027() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./underArmour2027Html')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Under Armour Türkiye · 2027 Planı"
      srcDoc={html}
      style={fill}
    />
  );
}
